import { AccessoryCategory, IAccessoryCategory } from '../module';
import {
  IConfigurationItem,
  IConfigurationItemData,
  IConfigurationItemFieldError,
  IConfigurationItemFieldErrorData
} from './configuration.types';

// Configuration models
export class Configuration {
  id?: number;
  owner?: string;
  price?: number;
  created_at?: string | Date;
  updated_at?: string | Date;
}

export class ConfigurationAnswer {
  id?: number;
  module?: number;
  question?: number;
  configuration?: number;
  choice?: number;
  value?: string | number;
}

export class ConfigurationItem implements IConfigurationItem {
  id?: number;
  item?: string;
  quantity?: number;
  unit?: string;
  order?: number;
  discount?: number;
  description?: string;
  unit_cost?: number;
  unit_price?: number;
  unit_discount?: number;
  net_price?: number;
  unit_net_price?: number;
  tariff_rate = 0;
  price?: number;
  answer?: number;
  configuration?: number;
  manually_updated_fields?: string[] = [];
  is_machine?: boolean;
  invalid_item?: boolean;
  is_obsolete?: boolean;
  country_of_origin = '';
  hs_code = '';

  accessory_category: IAccessoryCategory | number | null = null;

  constructor(data?: IConfigurationItemData) {
    // *for old integration
    this.quantity = 1;
    if (data) {
      // fix for if quantity was 0; would not pass check
      this.quantity = data.quantity ?? 0;

      if (data.id) {
        this.id = data.id;
      }
      if (data.item) {
        this.item = data.item;
      }
      if (data.unit) {
        this.unit = data.unit;
      }
      if (data.order) {
        this.order = data.order;
      }
      if (data.description) {
        this.description = data.description;
      }

      this.discount = data.discount ?? 0;
      this.unit_cost = Number(data.unit_cost ?? 0);
      this.unit_price = Number(data.unit_price ?? 0);
      this.unit_discount = Number(data.unit_discount ?? 0);
      this.net_price = data.net_price ?? 0;
      this.unit_net_price = data.unit_net_price ?? 0;
      this.price = data.price ?? 0;
      this.tariff_rate = data.tariff_rate ?? 0;
      this.is_machine = data.is_machine ?? false;
      this.invalid_item = data.invalid_item ?? false;
      this.is_obsolete = data.is_obsolete ?? false;

      if (data.country_of_origin) {
        this.country_of_origin = data.country_of_origin;
      }

      if (data.hs_code) {
        this.hs_code = data.hs_code;
      }

      if (data.answer) {
        this.answer = data.answer;
      }
      if (data.configuration) {
        this.configuration = data.configuration;
      }
      if (data.manually_updated_fields) {
        this.manually_updated_fields = data.manually_updated_fields;
      }
      if (data.accessory_category) {
        this.accessory_category =
          typeof data.accessory_category == 'number'
            ? data.accessory_category
            : new AccessoryCategory(data.accessory_category);
      }
    }
  }
}

export class ConfigurationItemFieldError
  implements IConfigurationItemFieldError {
  readonly description: string[] = [];
  readonly item: string[] = [];

  constructor(data?: IConfigurationItemFieldErrorData) {
    if (data) {
      if (data.description) {
        this.description = data.description;
      }
      if (data.item) {
        this.item = data.item;
      }
    }
  }

  clearErrors(): void {
    this.description.splice(0, this.description.length);
    this.item.splice(0, this.item.length);
  }

  static isConfigurationItemFieldError(
    data: IConfigurationItemFieldErrorData
  ): boolean {
    if (data.description && Array.isArray(data.description)) {
      return true;
    }
    if (data.item && Array.isArray(data.item)) {
      return true;
    }
    return false;
  }
}
